<button class="btn btn-link text-decoration-none btn-block text-white mt-4" (click)="calendar()">
  <i class="bx bx-calendar-star"></i>
  Calendar
</button>
